import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { jsonToCSS } from '../../../helpers/styles';
import { dimension } from '../WindowConfig';
import LabelContainer from './common/LabelContainer';
import Row from './common/Row';
import ValueContainer from './common/ValueContainer';

interface IBallTabAreaProps {
  lat: any;
  long: any;
  style?: any;
}

const Container = styled.div`
  ${jsonToCSS(dimension.ballTabPosition)};
`;

const CustomValueContainer = styled(ValueContainer)`
  text-align: right;
`;

const BallTabPosition: React.FunctionComponent<IBallTabAreaProps> = ({
  lat,
  long,
  ...rest
}) => {
  const showBallTabArea = useSelector(
    (state: any) => state.executor.s80.tacsit.showBallTabArea
  );
  return (
    <Container {...rest}>
      {showBallTabArea && (
        <Fragment>
          <Row>
            <LabelContainer width="20%">Lat:</LabelContainer>
            <CustomValueContainer width="70%">{lat}</CustomValueContainer>
          </Row>
          <Row>
            <LabelContainer width="20%">Lon:</LabelContainer>
            <CustomValueContainer width="70%">{long}</CustomValueContainer>
          </Row>
        </Fragment>
      )}
    </Container>
  );
};

export default BallTabPosition;
